import { render } from "./QBtnToggleColor.vue?vue&type=template&id=55c95fca"
import script from "./QBtnToggleColor.vue?vue&type=script&lang=js"
export * from "./QBtnToggleColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle});
